import React from 'react';
import PropTypes from 'prop-types';
import { component } from '@signal/prop-types';
import renderIf from '@signal/utils/renderIf';
import mutuallyExclusiveProperties from '@signal/prop-types/mutuallyExclusiveProperties';
import { createImgixUrl } from '@signal/utils/imgix';
import ProgressiveImage from '../ProgressiveImage';
import { Wrapper, Grid, Title, Description, Icon, Image } from './styles';
export function DesktopEmptyScreen(_ref) {
  var imageUrl = _ref.imageUrl,
      cta = _ref.cta,
      icon = _ref.icon,
      iconColor = _ref.iconColor,
      title = _ref.title,
      textColor = _ref.textColor,
      description = _ref.description,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(Grid, null, renderIf(icon, function () {
    return /*#__PURE__*/React.createElement(Icon, {
      as: icon,
      width: 60,
      height: 60,
      alt: title,
      iconColor: iconColor
    });
  }, function () {
    return /*#__PURE__*/React.createElement(ProgressiveImage, {
      src: imageUrl
    }, function (src, loading) {
      return /*#__PURE__*/React.createElement(Image, {
        imgStyle: {
          objectFit: loading ? 'cover' : 'contain'
        },
        src: src,
        alt: title
      });
    });
  }), /*#__PURE__*/React.createElement(Title, {
    color: textColor
  }, title), renderIf(description, /*#__PURE__*/React.createElement(Description, {
    color: textColor
  }, description)), cta));
}
DesktopEmptyScreen.defaultProps = {
  imageUrl: createImgixUrl('purecars-signal', '/empty-state/empty-state-graphic@2x.png', {
    w: 454
  })
};
DesktopEmptyScreen.propTypes = mutuallyExclusiveProperties({
  icon: component,
  iconColor: PropTypes.string,
  imageUrl: PropTypes.string,
  textColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  cta: component
}, ['icon', 'imageUrl'], true);
export default DesktopEmptyScreen;